import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { useTheme } from './lib/theme';
import { AppLayout } from './components/layout/AppLayout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { HomePage } from './pages/HomePage';
import { DemoPage } from './pages/DemoPage';
import { LoginPage } from './pages/LoginPage';
import { AuthCallbackPage } from './pages/AuthCallbackPage';
import { DashboardPage } from './pages/DashboardPage';
import { ChatPage } from './pages/ChatPage';
import { RepositoriesPage } from './pages/RepositoriesPage';
import { ArchitecturePage } from './pages/ArchitecturePage';
import { KnowledgeGraphPage } from './pages/KnowledgeGraphPage';

function ThemedToaster() {
  const { theme } = useTheme();
  return (
    <Toaster
      position="bottom-right"
      toastOptions={{
        style: {
          background: theme === 'dark' ? '#18181B' : '#FFFFFF',
          border: `1px solid ${theme === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)'}`,
          color: theme === 'dark' ? '#FAFAFA' : '#09090B',
          fontSize: '13px',
        },
      }}
    />
  );
}

function App() {
  return (
    <>
      <Routes>
        {/* Public */}
        <Route path="/"             element={<HomePage />} />
        <Route path="/demo"         element={<DemoPage />} />
        <Route path="/login"        element={<LoginPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />

        {/* Protected — requires valid JWT */}
        <Route element={<ProtectedRoute />}>
        {/* App — wrapped in sidebar + topbar layout */}
        <Route element={<AppLayout />}>
          <Route path="/dashboard"     element={<DashboardPage />} />
          <Route path="/conversations" element={<ChatPage />} />
          <Route path="/repositories"  element={<RepositoriesPage />} />
          <Route path="/architecture"  element={<ArchitecturePage />} />
          <Route path="/knowledge"     element={<KnowledgeGraphPage />} />
          {/* Legacy redirect */}
          <Route path="/chat" element={<Navigate to="/conversations" replace />} />
          {/* Coming soon — redirect to dashboard for now */}
          <Route path="/integrations" element={<Navigate to="/dashboard" replace />} />
          <Route path="/team"         element={<Navigate to="/dashboard" replace />} />
          <Route path="/settings"     element={<Navigate to="/dashboard" replace />} />
        </Route>
        </Route>{/* end ProtectedRoute */}

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <ThemedToaster />
    </>
  );
}

export default App;
